export const BLACKED_ONBOARDING_KEY = "blackred-studio.blacked-onboarding.v1";
export const BLACKED_START_EVENT = "blackred:start-blacked";

export function startBlackedOnboarding() {
  window.dispatchEvent(new Event(BLACKED_START_EVENT));
}
